import $ from 'jquery';
import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { InlineSuggestedParamValueColumnPrompt } from './param-inline-editable/prompt';

export class SuggestedParamValueColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n, view }) {
    const title = newI18n.getString(_TL_('Suggested param value'));

    super({
      name: 'suggestedParamValue',
      property: 'Opportunities/SuggestedParamValue',
      title,
      bodyClasses: ['grid-column-suggested-param-value', 'actionable'],
      colClasses: ['col-mediumText'],
      helpId: 'Pop_BA_Recommendations_SuggestedValue',
      type: 'string',
      editable: () => true,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
    this.newI18n = newI18n;
    this.view = view;
  }

  template({
    value: { Opportunities },
  }) {
    const opportunity = _.first(Opportunities);
    if (!_.isUndefined(opportunity.Param1) || !_.isEmpty(opportunity.RawSuggParam1)) {
      return !_.isUndefined(opportunity.Param1) ? opportunity.Param1 : opportunity.RawSuggParam1;
    } else if (!_.isUndefined(opportunity.Param2) || !_.isEmpty(opportunity.RawSuggParam2)) {
      return !_.isUndefined(opportunity.Param2) ? opportunity.Param2 : opportunity.RawSuggParam2;
    } else if (!_.isUndefined(opportunity.Param3) || !_.isEmpty(opportunity.RawSuggParam3)) {
      return !_.isUndefined(opportunity.Param3) ? opportunity.Param3 : opportunity.RawSuggParam3;
    }
    return '';
  }

  get property() {
    return {
      get: _.identity,
      property: 'Opportunities/SuggestedParamValue',
    };
  }

  onPrompt({
    event,
    item,
    newPosition,
  }) {
    const opportunity = _.first(item.Opportunities);
    let field;
    let param;
    if (!_.isUndefined(opportunity.Param1) || !_.isEmpty(opportunity.RawSuggParam1)) {
      field = 'Param1';
      param = {
        Param1: !_.isUndefined(opportunity.Param1) ?
          opportunity.Param1 : opportunity.RawSuggParam1,
      };
    } else if (!_.isUndefined(opportunity.Param2) || !_.isEmpty(opportunity.RawSuggParam2)) {
      field = 'Param2';
      param = {
        Param2: !_.isUndefined(opportunity.Param2) ?
          opportunity.Param2 : opportunity.RawSuggParam2,
      };
    } else if (!_.isUndefined(opportunity.Param3) || !_.isEmpty(opportunity.RawSuggParam3)) {
      field = 'Param3';
      param = {
        Param3: !_.isUndefined(opportunity.Param3) ?
          opportunity.Param3 : opportunity.RawSuggParam3,
      };
    }

    InlineSuggestedParamValueColumnPrompt({
      position: newPosition,
      item: param,
      field,
      view: this.view,
      i18n: this.i18n,
      newI18n: this.newI18n,
      key: $(event.target).parents('tr[data-key]').data('key'),
    });
  }
}
